import { render, staticRenderFns } from "./QA_th.vue?vue&type=template&id=2f6d02d0&scoped=true&"
import script from "./QA_th.vue?vue&type=script&lang=js&"
export * from "./QA_th.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d02d0",
  null
  
)

export default component.exports